/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DashboardYearlyTransactionSummary { 
    locationCode?: string | null;
    month?: string | null;
    totalTransactions?: number;
    totalAmount?: number;
}

